import styled from 'styled-components/macro';

export default styled.h3`
  color: ${props => props.theme.primaryColor};
  margin: ${props => (props.noMargin ? '0' : '.4em')};
  font-weight: normal;
  font-size: 1.375rem;
`;
